/**
 * @copyright       Palace Resorts
 * @description     Mensajes para la sección de Reportes
 * @author          cchan
 * @creationDate    20 de septiembre del 2021
 */

 export default {
    fallbackLocale: 'ESP',
    locale: 'ESP',
    messages: {
      'ESP': {
        'lblTitle': 'Reportes',
      },
      'ENG': {
        'title': 'Reports',
      }
    }
  }